import type { PayloadAction } from '@reduxjs/toolkit';
import { arrayMove } from '@dnd-kit/sortable';
import type { CampaignEditorReducerCreator } from '../types';

const reorderBlocks = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ activeId: string; overId: string }>) => {
    const { activeId, overId } = action.payload;
    if (!state.blocks || activeId === overId) return;
    const activeIndex = state.blocks.findIndex((block) => block.id === activeId);
    const overIndex = state.blocks.findIndex((block) => block.id === overId);
    if (activeIndex === -1 || overIndex === -1) return;
    state.blocks = arrayMove(state.blocks, activeIndex, overIndex);
  });

export default reorderBlocks;
